"use strict";

reports.classy.controller({
	name: "ReportsController", 
	inject: ["$scope", "FirstRunModalService"],
    init: function() {
        this.FirstRunModalService.fireFirstRun("reports");
    }
});

